export type NavItem = {
  path: string;
  label: string;
  icon:
    | "overview"
    | "tenants"
    | "network"
    | "leaders"
    | "followers"
    | "risk"
    | "bridge"
    | "audit"
    | "support"
    | "settings"
    | "status"
    | "login";
};

export const dashboardNav: NavItem[] = [
  { path: "/dashboard/overview", label: "Overview", icon: "overview" },
  { path: "/dashboard/tenants", label: "Tenants", icon: "tenants" },
  { path: "/dashboard/copy-network", label: "Copy Network", icon: "network" },
  { path: "/dashboard/leaders", label: "Leaders", icon: "leaders" },
  { path: "/dashboard/followers", label: "Followers", icon: "followers" },
  { path: "/dashboard/risk-controls", label: "Risk Controls", icon: "risk" },
  { path: "/dashboard/bridge", label: "Bridge Status", icon: "bridge" },
  { path: "/dashboard/audit", label: "Audit Trail", icon: "audit" },
  { path: "/dashboard/support", label: "Support Ops", icon: "support" },
  { path: "/dashboard/settings", label: "Settings", icon: "settings" },
];

export const utilityNav: NavItem[] = [
  { path: "/status", label: "Public Status", icon: "status" },
  { path: "/login", label: "Login Preview", icon: "login" },
];

export function titleForPath(pathname: string): { title: string; subtitle: string } {
  const map: Record<string, { title: string; subtitle: string }> = {
    "/": {
      title: "Command Center",
      subtitle: "Redirecting into the operations console",
    },
    "/login": {
      title: "Sign in",
      subtitle: "Authentication preview — not enabled",
    },
    "/dashboard": {
      title: "Overview",
      subtitle: "Platform health and operational posture",
    },
    "/dashboard/overview": {
      title: "Overview",
      subtitle: "Platform health and operational posture",
    },
    "/dashboard/tenants": {
      title: "Tenants",
      subtitle: "Broker and tenant operating units",
    },
    "/dashboard/copy-network": {
      title: "Copy Network",
      subtitle: "Leader-to-follower relationship map",
    },
    "/dashboard/leaders": {
      title: "Leaders",
      subtitle: "Signal providers and strategy health",
    },
    "/dashboard/followers": {
      title: "Followers",
      subtitle: "Investor accounts and copy posture",
    },
    "/dashboard/risk-controls": {
      title: "Risk Controls",
      subtitle: "Execution gates and protective limits",
    },
    "/dashboard/bridge": {
      title: "Bridge Status",
      subtitle: "Execution bridge and queue readiness",
    },
    "/dashboard/audit": {
      title: "Audit Trail",
      subtitle: "Immutable operational event timeline",
    },
    "/dashboard/support": {
      title: "Support Ops",
      subtitle: "Incident board and escalation lanes",
    },
    "/dashboard/settings": {
      title: "Settings",
      subtitle: "Brand, environment, and readiness",
    },
    "/status": {
      title: "Platform Status",
      subtitle: "Public health and readiness signals",
    },
  };

  return (
    map[pathname] ?? {
      title: "Not Found",
      subtitle: "Route is not available in this preview console",
    }
  );
}
